import { initializeBookmarks } from './elements/bookmark.js';
import { initializeResizeObserver } from './global/resize-observer.js';
import { initializeLiveChat } from './fragments/live_chat.js';

document.addEventListener('DOMContentLoaded', () => {
  initializeBookmarks();
  initializeResizeObserver({
    element: document.querySelector('.Hero__Banner__HeaderWrapper'),
    properties: [{
      boxProperty: 'height',
      cssProperty: '--hero-banner-header-height',
    }],
  });
  initializeLiveChat();
});
